import React from 'react';
import {
  CollapsibleOuterDiv,
  CollapsibleInnerDiv,
  CollapsibleInnerHeader,
  CollapsibleOuterUnderlineGray,
  CollapsibleOuterUnderlineOrange,
  ArrowUp,
  ArrowDown
} from '../ServicePageContainer';
import { MenuItemComponent } from './MenuItemComponent';

class CollapsableSubMenuWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
    this.togglePanel = this.togglePanel.bind(this);
  }

  togglePanel(e) {
    this.setState({ open: !this.state.open });
  }

  render() {
    const { serviceNav, currentPageUrl, currentPageHeader } = this.props;

    var currentMenuList = [];
    var header;

    if (currentPageUrl.split('/').length > 3) {
      var hej = serviceNav.childNavigationLinks.find(item => item.name === currentPageHeader);
      currentMenuList = hej;
      header = currentPageHeader;
    } else {
      currentMenuList = serviceNav;
      header = currentPageHeader;
    }

    return (
      <div>
        <CollapsibleOuterDiv onClick={e => this.togglePanel(e)}>
          <CollapsibleInnerDiv>
            <CollapsibleInnerHeader>{header}</CollapsibleInnerHeader>
            {currentMenuList &&
            currentMenuList.childNavigationLinks &&
            currentMenuList.childNavigationLinks.length > 0 ? (
              this.state.open ? (
                <ArrowUp />
              ) : (
                <ArrowDown />
              )
            ) : (
              ''
            )}
          </CollapsibleInnerDiv>
        </CollapsibleOuterDiv>
        {this.state.open ? <CollapsibleOuterUnderlineGray /> : ''}
        {this.state.open && currentMenuList && currentMenuList.childNavigationLinks
          ? currentMenuList.childNavigationLinks.map(menuItem => (
              <MenuItemComponent menuItem={menuItem} url={menuItem.url} />
            ))
          : ''}
        <CollapsibleOuterUnderlineOrange />
      </div>
    );
  }
}

export default CollapsableSubMenuWrapper;
